import { useState } from "react";
import type { SourceSnapshot } from "@tuit/shared-types";
import styles from "../styles/components/SourceGalleryView.module.css";

export function SourceGalleryView({ snapshot }: { snapshot: SourceSnapshot }) {
  const items = snapshot.items.filter((item) => item.thumbnail);
  const [index, setIndex] = useState(0);

  if (items.length === 0) {
    return <div className={styles.empty}>No images in this source.</div>;
  }

  const current = items[Math.min(index, items.length - 1)]!;

  return (
    <div className={styles.gallery}>
      <div className={styles.main}>
        <button
          type="button"
          className={styles.navBtn}
          onClick={() => setIndex((i) => Math.max(0, i - 1))}
          disabled={index === 0}
          aria-label="Previous"
        >
          ‹
        </button>
        <a href={current.url} target="_blank" rel="noreferrer" className={styles.imageLink}>
          <img src={current.thumbnail!} alt={current.title} className={styles.image} />
        </a>
        <button
          type="button"
          className={styles.navBtn}
          onClick={() => setIndex((i) => Math.min(items.length - 1, i + 1))}
          disabled={index === items.length - 1}
          aria-label="Next"
        >
          ›
        </button>
      </div>
      <div className={styles.info}>
        <a href={current.url} target="_blank" rel="noreferrer" className={styles.title}>
          {current.title}
        </a>
        {current.author && <span className={styles.author}>{current.author}</span>}
        <span className={styles.counter}>{index + 1} / {items.length}</span>
      </div>
    </div>
  );
}
